import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HeartIcon from '@tradera/blueprint/theme/icons2/heart.svg?jsx';
import WatchlistMenu from './watch-list-menu';
import { HOVER_MENUS } from './hover-menu/constants';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { useSelector, useDispatch } from 'react-redux';
import HeartFilledIcon from '@tradera/blueprint/theme/icons2/heart-fill.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import {
    closeCategoryDropdownMenu,
    closeProfileMenu,
    closeWishListSideSheet,
    openWishListSideSheet
} from 'tradera/state/ui/reducer';

const WishlistLink = ({
    onClick,
    mouseOver,
    mouseOut,
    transparentHeader,
    showMenu
}) => {
    const { t } = useTranslator();
    const dispatch = useDispatch();

    const { isOpen } = useSelector((state) => state.ui.wishListSideSheet);
    const isWishListSideSheetEnabled = useIsFeatureEnabled(
        'wish-list-side-sheet'
    );

    const { toLocalizedUrl } = useUrlLocalizer();

    const wishListItemIds = useSelector((state) => state.items.wishListItemIds);

    const [prevNumWishListItemIds, setPrevNumWishListItemIds] = useState(null);
    const [heartBlink, setHeartBlink] = useState(false);

    useEffect(() => {
        if (!isWishListSideSheetEnabled) return;

        if (
            prevNumWishListItemIds !== null &&
            prevNumWishListItemIds < wishListItemIds.length
        ) {
            setHeartBlink(true);
            setTimeout(() => setHeartBlink(false), 600);
        }

        setPrevNumWishListItemIds(wishListItemIds.length);
    }, [wishListItemIds, isWishListSideSheetEnabled, prevNumWishListItemIds]);

    const handleOnClick = (e) => {
        if (isWishListSideSheetEnabled) {
            if (isOpen) {
                dispatch(closeWishListSideSheet());
            } else {
                dispatch(closeCategoryDropdownMenu());
                dispatch(closeProfileMenu());

                dispatch(openWishListSideSheet());
            }
        }

        onClick(e, HOVER_MENUS.WISHLIST);
    };

    return (
        <div
            onMouseEnter={() => mouseOver(HOVER_MENUS.WISHLIST)}
            onMouseLeave={mouseOut}>
            <Button
                href={
                    isWishListSideSheetEnabled
                        ? null
                        : toLocalizedUrl('/my/wish-list')
                }
                className={`slim-header__button slim-header__link-spacing d-flex align-items-center ${
                    transparentHeader ? 'btn-transparent-header' : ''
                } ${showMenu ? 'active' : ''}`}
                rel="nofollow"
                data-ga-category="Top navigation"
                data-ga-action="Watchlist menu"
                data-ga-label="Link - Wishlist from NavBar"
                data-nav-wishlist
                onClick={handleOnClick}
                variant={transparentHeader ? 'inverted' : null}
                theme="text">
                <div className="position-relative">
                    <HeartIcon className="icon icon-md" />
                    {heartBlink && (
                        <HeartFilledIcon className="position-absolute icon icon-md icon-danger stroke-black fade-in-out" />
                    )}
                </div>

                <span
                    className={`slim-header__link-text d-none d-xl-inline pl-xl-1`}>
                    {t('siteHeader_wishlist')}
                </span>
            </Button>
            <WatchlistMenu showMenu={showMenu} />
        </div>
    );
};

WishlistLink.propTypes = {
    onClick: PropTypes.func,
    mouseOver: PropTypes.func,
    mouseOut: PropTypes.func,
    showMenu: PropTypes.bool
};

export default React.memo(WishlistLink);
